"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeDTO = exports.MembershipStatusTranslation = exports.MembershipStatus = void 0;
const validated_data_1 = require("../../data-validator/dto/validated-data");
var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus[MembershipStatus["VIGENTE"] = 1] = "VIGENTE";
    MembershipStatus[MembershipStatus["SUSPENDIDA"] = 2] = "SUSPENDIDA";
    MembershipStatus[MembershipStatus["CANCELADA"] = 3] = "CANCELADA";
    MembershipStatus[MembershipStatus["COMPLETADA"] = 4] = "COMPLETADA";
    MembershipStatus[MembershipStatus["APROBACION"] = 5] = "APROBACION";
})(MembershipStatus || (exports.MembershipStatus = MembershipStatus = {}));
var MembershipStatusTranslation;
(function (MembershipStatusTranslation) {
    MembershipStatusTranslation["VIGENTE"] = "Vigente";
    MembershipStatusTranslation["SUSPENDIDA"] = "Suspendida";
    MembershipStatusTranslation["CANCELADA"] = "Cancelada";
    MembershipStatusTranslation["NO_EMITIDA"] = "No emitida";
    MembershipStatusTranslation["COMPLETADA"] = "Completada";
    MembershipStatusTranslation["APROBACION"] = "Aprobaci\u00F3n";
})(MembershipStatusTranslation || (exports.MembershipStatusTranslation = MembershipStatusTranslation = {}));
class EmployeeDTO {
    constructor(partial) {
        Object.assign(this, partial);
    }
    static fromCustomer(customer, registerStatus, paymentFrequency, response) {
        return new EmployeeDTO({
            id: customer.id,
            email: customer.email,
            names: customer.names,
            paternalLastName: customer.paternalLastName,
            maternalLastName: customer.maternalLastName,
            phone: customer.phone,
            productName: customer.productName,
            paymentFrequency: paymentFrequency,
            taxId: customer.taxId,
            status: registerStatus,
            apiErrorMessage: response && 'message' in response
                ? response.message
                : 'Ya registrado en otra empresa',
        });
    }
    static mapMembershipStatus(status) {
        switch (status) {
            case MembershipStatus.VIGENTE:
                return MembershipStatusTranslation.VIGENTE;
            case MembershipStatus.SUSPENDIDA:
                return MembershipStatusTranslation.SUSPENDIDA;
            case MembershipStatus.CANCELADA:
                return MembershipStatusTranslation.CANCELADA;
            default:
                return MembershipStatusTranslation.NO_EMITIDA;
        }
    }
    mapToMembersData() {
        var _a;
        return {
            columns: [
                {
                    columnName: 'Apellido Paterno',
                    columnValue: this.paternalLastName || '',
                    isValid: true,
                    isRepeated: false,
                    cell: 'A1',
                    isOriginalRepeated: false,
                    type: validated_data_1.ColumnType.TEXT,
                    isVisible: true,
                    isRequiredInFile: true,
                },
                {
                    columnName: 'Apellido Materno',
                    columnValue: this.maternalLastName || '',
                    isValid: true,
                    isRepeated: false,
                    cell: 'B1',
                    isOriginalRepeated: false,
                    type: validated_data_1.ColumnType.TEXT,
                    isVisible: true,
                    isRequiredInFile: true,
                },
                {
                    columnName: 'Nombres',
                    columnValue: this.names || '',
                    isValid: true,
                    isRepeated: false,
                    cell: 'C1',
                    isOriginalRepeated: false,
                    type: validated_data_1.ColumnType.TEXT,
                    isVisible: true,
                    isRequiredInFile: true,
                },
                {
                    columnName: 'RFC',
                    columnValue: this.taxId || '',
                    isValid: true,
                    isRepeated: false,
                    cell: 'D1',
                    isOriginalRepeated: false,
                    type: validated_data_1.ColumnType.RFC,
                    isVisible: true,
                    isRequiredInFile: true,
                },
                {
                    columnName: 'Correo Electronico',
                    columnValue: this.email || '',
                    isValid: true,
                    isRepeated: false,
                    cell: 'E1',
                    isOriginalRepeated: false,
                    type: validated_data_1.ColumnType.EMAIL,
                    isVisible: true,
                    isRequiredInFile: true,
                },
                {
                    columnName: 'Telefono',
                    columnValue: this.phone || '',
                    isValid: true,
                    isRepeated: false,
                    cell: 'F1',
                    isOriginalRepeated: false,
                    type: validated_data_1.ColumnType.PHONE,
                    isVisible: true,
                    isRequiredInFile: true,
                },
                {
                    columnName: 'Producto',
                    columnValue: this.productName || '',
                    isValid: true,
                    isRepeated: false,
                    cell: 'G1',
                    isOriginalRepeated: false,
                    type: validated_data_1.ColumnType.TEXT,
                    isVisible: true,
                    isRequiredInFile: true,
                },
                {
                    columnName: 'ID',
                    columnValue: this.id || '',
                    isValid: true,
                    isRepeated: false,
                    cell: 'I1',
                    isOriginalRepeated: false,
                    type: validated_data_1.ColumnType.TEXT,
                    isVisible: false,
                    isRequiredInFile: false,
                },
                {
                    columnName: 'Prima Restante',
                    columnValue: ((_a = this.remainingPremium) === null || _a === void 0 ? void 0 : _a.toString()) || '0',
                    isValid: true,
                    isRepeated: false,
                    cell: 'J1',
                    isOriginalRepeated: false,
                    type: validated_data_1.ColumnType.TEXT,
                    isVisible: true,
                    isRequiredInFile: false,
                },
                {
                    columnName: 'Fecha de Activación',
                    columnValue: this.activationDate
                        ? new Date(this.activationDate).toLocaleDateString('es-ES')
                        : '',
                    isValid: true,
                    isRepeated: false,
                    cell: 'K1',
                    isOriginalRepeated: false,
                    type: validated_data_1.ColumnType.TEXT,
                    isVisible: true,
                    isRequiredInFile: false,
                },
                {
                    columnName: 'Estado de Membresía',
                    columnValue: this.membershipStatus || 'Inactivo',
                    isValid: true,
                    isRepeated: false,
                    cell: 'L1',
                    isOriginalRepeated: false,
                    type: validated_data_1.ColumnType.TEXT,
                    isVisible: true,
                    isRequiredInFile: false,
                },
            ],
        };
    }
    static toMembersData(employees) {
        return employees.map((employee) => employee.mapToMembersData());
    }
    static fromBasicInfo(basicInfo) {
        return new EmployeeDTO({
            id: basicInfo.id,
            names: basicInfo.names,
            paternalLastName: basicInfo.paternalLastName,
            maternalLastName: basicInfo.maternalLastName,
            email: basicInfo.email,
            phone: basicInfo.phone,
            taxId: basicInfo.taxId,
            productName: basicInfo.productName,
            paymentFrequency: basicInfo.paymentFrequency,
            status: basicInfo.status,
            incorporationStatus: basicInfo.incorporationStatus,
            lastDateRemainderEmailSent: basicInfo.lastDateRemainderEmailSent,
        });
    }
}
exports.EmployeeDTO = EmployeeDTO;
//# sourceMappingURL=employee-dto.js.map